import { Island } from '../island.class';
import { Vertex3 } from '../../../spatial-classes';

export const getCenterOffsetsCfn = (island: Island, angle = 0, includeCountertop = false): { front: number; left: number; back: number; right: number; } => {
	const offsets = { front: 0, left: 0, back: 0, right: 0 };

	try {
		island.panels.children.forEach((p) => {
			const { corners } = p.getSidePoints({ includeCountertop, translate: true, rotate: true });
			const zero = new Vertex3();

			// Rotate all 4 corners -- corner islands with 45-degree panels can have
			// different x/z extents on each corner after rotation.
			corners.forEach((corner) => { corner.rotateAxis(zero, angle, 'y'); });

			corners.forEach((corner) => {
				offsets.front = Math.min(offsets.front, corner.z);
				offsets.left = Math.min(offsets.left, corner.x);
				offsets.back = Math.max(offsets.back, corner.z);
				offsets.right = Math.max(offsets.right, corner.x);
			});
		});
	} catch (error) {
		console.error(`getCenterOffsetsCfn:Error calculating center offsets for island ${island.id}:`, error);
	}

	return offsets;
}
